<template>
  <div>
    <a-modal id='handitem_x' :class='islang=="eng"?"div_eng":"div_big"' v-model="visible" width='743px' on-ok="handleOk" @cancel="handleCancel(0)" :footer="null"
      :keyboard='false' :maskClosable='false' :dialog-style="{top: onlinestate == 'pc' ? '26%' : onlinestate == 'ipad' ? '22vh' : '11vh'}">
      <div class='mark-file' >
        <div style="width: 100%;font-size: 21px;text-align: center;color:#0C8B97;font-weight: 600;"  class="my_fonts" :style="{ fontSize: islang == 'eng'&&onlinestate !=='pc' ?'17px':'17px'}">
          <!-- color: #0C8B97; -->
          {{$lang.zjmz1}}
        </div>
        <div style="width: 1rem;height: 20px;"></div>
        <div style="height:1px;background-color:#0C8B97"></div>
      </div>
      <div solt='title' style="position: relative;">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div style="font-size: 16px;margin-top : 1.5rem; color: #000;max-height:320px;overflow-y: auto;">
        <!-- <div class='look_w' style="margin-bottom: 1rem;">{{params.text_welcome}}</div> -->
        <div class='fonts look_l eng_font eng_font_title' style="font-size: 17px;font-weight:600;margin-bottom:0.5rem">{{$lang.zjmz2}}</div>
        <pre class='fonts look_l eng_font' style="font-size: 16px;">{{$lang.zjmz3}}</pre>
        <div class='fonts look_l eng_font eng_font_title' style="font-size: 17px;font-weight:600;margin:0.5rem 0">{{$lang.zjmz4}}</div>
        <pre class='fonts look_l eng_font' style="font-size: 16px;">{{$lang.zjmz5}}</pre>
      </div>
      <div style="margin: 1rem auto .5rem;display: flex;justify-content: space-between;width: 50%; min-width: 240px;">
        <button class="btn_en" id='mybtn_iconc' @click='handisok'>{{$lang.agree}}</button>
        <button class="btn_en" id='mybtn_sc' @click='$router.push("/")'>{{$lang.an_ree}}</button>
      </div>
    </a-modal>
  </div>
</template>

<script>
  export default {
    props: ['items'],
    data() {
      return {
        onlinestate:sessionStorage['onlinestate'],
        islang: window.localStorage.guanwanglang,
        visible: true,
        params: {
          disclaimer_body: '',
          disclaimer_body2:''
        }
      }
    },
    mounted() {
      // this.getdate()
      if (window.sessionStorage['isagree_bond']) {
        this.visible = false
      }
    },
    methods: {
      handisok() {
        window.sessionStorage['isagree_bond'] = '1'
        this.visible = false
      },
      // getdate() {
      //   this.$ajax({
      //     method: 'post',
      //     url: this.$api.getGroupDisclaimer,
      //     data: {
      //       "lan": window.localStorage.guanwanglang,
      //       // "noticeid": this.items.noticeid
      //     }
      //   }).then(res => {
      //     if (res.data.qmiscode === 1000) {
      //       this.params = res.data
      //     }
      //   })
      // },
      handleCancel() {
        this.$router.push("/")
        // this.$emit('child')
      },
      handleOk() {
        // console.log(111112)
      },
    }
  }
</script>

<style>
  .div_eng{
    .my_fonts{
      font-size: 15px !important;
    }
    .eng_font{
      font-size: 15px !important;
    }
    .eng_font_title{
      font-size: 16px !important;
    }
    .btn_en{
      font-size: 15px !important;
    }
  }
  #mybtn_sc {
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    background-color: #eaeaea;
    border: 0;
    width: 5rem;
    height: 2rem;
    outline: none;
    padding: .3rem .6rem;
    border-radius: 6px;
    /* margin: 0 2rem; */
  }

  #mybtn_iconc {
    cursor: pointer;
    /* margin: 0 2rem; */
    border-radius: 6px;
    height: 2rem;
    width: 5rem;
    color: #fff;
    font-size: 16px;
    background-color: #0C8B97;
    border: 0;
    outline: none;
    padding: .3rem .6rem;
  }

  #mybtn_sc:hover {
    color: #09666E;
    border: 1px solid #09666E;
    background-color: #fff;
  }

  #handitem_x .ant-modal-close-x {
    font-size: 18px;
    top: 5px;
    position: relative;
  }
  #handitem_x .ant-modal{
    border-top: #09666E;
    border-top-width: 8px;
    border-top-style: solid;
    border-bottom: #09666E;
    border-bottom-width: 8px;
    border-bottom-style: solid;
    padding-bottom: 0 !important;
  }

  #handitem_x .ant-modal-content {
    border-radius: 0 !important;
  }

  #handitem_x .ant-modal-content svg:hover {
    color: #09666E !important;
  }

  .look_w {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/pages/zichanguanli/bond_handitem.vue